import * as React from "react";

export type OnChangeAlignField = (value: any) => void;

export interface PureAlignFieldProps {
	label: string;
	value: any;
	onChange: OnChangeAlignField;
	text: string;
	description: string;
}

export class PureAlignField extends React.Component<PureAlignFieldProps> {
	render() {
		const aligns = ["left", "center", "right", "justify"];
		return (
			<div className="property-item row">
				<div title={this.props.label} className="property-text">
					<div className="title">{this.props.text || this.props.label.split(/(?=[A-Z])/).map(item => item.charAt(0).toUpperCase() + item.slice(1) + " ")}</div>
					<div className="sub-title">{this.props.description || this.props.label}</div>
				</div>
				<div className="col">
					<div className="property-alignment row">
						{aligns.map(align => {
							return (
								<button
									className={this.props.value === align ? "active" : ""}
									onClick={() => this.props.onChange(align)}
									key={align}
								>
									<i className={"fas fa-align-" + align} />
								</button>
							);
						})}
					</div>
				</div>
			</div>
		);
	}
}
